/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Status_Inactive_DescriptionInputs */



/**
* | output |
* | --- |
* | "Inactive and not monitoring" |
*
* @param {Compliance_Status_Inactive_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_status_inactive_description = /** @type {((inputs?: Compliance_Status_Inactive_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Status_Inactive_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Inaktiv und überwacht nicht")
	return /** @type {LocalizedString} */ ("Inactive and not monitoring")
});